module.exports = "/images/vessel-12.jpg";